import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import Loader from "../../shared/loader";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";

const AddInvoice = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const selectInputRef = useRef();
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [lrDate, setLrDate] = useState();
  const [partyData, setPartyData] = useState([]);
  const [products, setProducts] = useState([]);
  const [transports, setTransports] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [transportId, setTransportId] = useState("");
  const [charges, setCharges] = useState([]);
  const [showQuickAddParty, setShowQuickAddParty] = useState(false);
  const [quickAddPartyForm, setQuickAddPartyForm] = useState({
    name: "",
    email: "",
    contact_no: "",
    city_id: "",
    state_id: "",
    address: "",
    pincode: "",
    gst_no: "",
    pan_no: "",
    country_id: 101,
  });
  const [quickAddPartyStateDrp, setQuickAddPartyStateDrp] = useState([]);
  const [quickAddPartyCityDrp, setQuickAddPartyCityDrp] = useState([]);
  const [isSavingParty, setIsSavingParty] = useState(false);
  const [showQuickAddTransport, setShowQuickAddTransport] = useState(false);
  const [quickAddTransportForm, setQuickAddTransportForm] = useState({
    name: "",
    gst_no: "",
  });
  const [isSavingTransport, setIsSavingTransport] = useState(false);
  const [productData, setProductData] = useState({
    name: "",
    product_id: "",
    sub_product_id: "",
    unit: "",
    in_stock: "",
    gst: "",
    qty: "",
    rate: "",
    amount: "",
  });
  const [seller, setSeller] = useState({
    address: "",
    city_id: "",
    city_name: "",
    gst_no: "",
    pan_no: "",
    state_id: "",
    state_name: "",
    pincode: "",
    name: "",
  });
  const [formData, setFormData] = useState({
    party_id: "",
    invoice_no: "",
    prefix: "",
    insurance: "",
    insurance_amount: "0",
    is_igst: "",
    invoice_memo: "Debit Memo",
    is_payable: "0",
    round_off: "0",
    lr_no: "",
    lr_date: "",
    transport_id: null,
    vehicle_no: "",
    transport_gst: "",
    destination_place: "",
    sub_total: "0",
    tax_amount: "0",
    total_amount: 0,
    amount_received: 0,
    received_type: "CASH",
    date: "",
    ship_name: "",
    ship_address_one: "",
    ship_city_id: "",
    city_name: "",
    ship_state_id: "",
    state_id: "",
    state_name: "",
    ship_pincode: "",
    ship_gst_no: "",
    ship_pan_no: "",
    discount_type: "Discount Before Tax",
    discount_rate: "0",
    discount_amount: "0",
    items: [],
  });
  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  const discountOptions = [
    { value: "Discount Before Tax", label: "Discount Before Tax" },
    { value: "Discount After Tax", label: "Discount After Tax" },
  ];
  const memoOptions = [
    { value: "Debit Memo", label: "Debit Memo" },
    { value: "Cash Memo", label: "Cash Memo" },
  ];

  const taxOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ];

  const modeTypeDrp = [
    { value: "CASH", label: "Cash" },
    { value: "UPI", label: "UPI" },
    { value: "CARD", label: "Card" },
    { value: "BANK", label: "Bank Transfer" },
    { value: "CHEQUE", label: "Cheque" },
  ];

  const selectStyles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  const getParty = (party_id) => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [0]}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            address: raw.address ? raw.address : "",
            pincode: raw.pincode ? raw.pincode : "",
            city_name: raw.city_name ? raw.city_name : "",
            gst_no: raw.gst_no ? raw.gst_no : "",
            pan_no: raw.pan_no ? raw.pan_no : "",
            state_name: raw.state_name ? raw.state_name : "",
            state_id: raw.state_id,
            city_id: raw.city_id,
            name: raw.name,
            label: raw.name + " - " + raw.contact_no,
            value: raw.id,
          };
        });
        setPartyData(pt);
        if (party_id) {
          const party = pt.find((r) => r.value == party_id);
          if (party) {
            setSeller(party);
            setFormData({
              ...formData,
              party_id: party_id,
              ship_name: party.name,
              ship_address_one: party.address,
              ship_city_id: party.city_id,
              ship_state_id: party.state_id,
              ship_pincode: party.pincode,
              ship_gst_no: party.gst_no,
              ship_pan_no: party.pan_no,
            });
          }
        }
      }
    });
  };
  const getInvoice = () => {
    axios.post(API_URL.INVOICE_LATEST, {}).then((res) => {
      if (res.data.status === 1) {
        setFormData({ ...formData, prefix: res.data.prefix, invoice_no: res.data.data });
      }
    });
  };

  const getEdit = () => {
    axios.post(API_URL.INVOICE_GET, { id: id }).then((res) => {
      if (res.data.status == 1) {
        setFormData({
          party_id: res.data.data.party_id ? res.data.data.party_id : "",
          invoice_no: res.data.data.invoice_no ? res.data.data.invoice_no : "",
          insurance: res.data.data.insurance ? res.data.data.insurance : "",
          insurance_amount: res.data.data.insurance_amount ? res.data.data.insurance_amount : "0",
          is_igst: res.data.data.is_igst ? res.data.data.is_igst : "",
          invoice_memo: res.data.data.invoice_memo ? res.data.data.invoice_memo : "",
          is_payable: res.data.data.is_payable ? res.data.data.is_payable : "0",
          round_off: res.data.data.round_off ? res.data.data.round_off : "0",
          lr_no: res.data.data.lr_no ? res.data.data.lr_no : "",
          lr_date: res.data.data.lr_date ? res.data.data.lr_date : "",
          transport_id: res.data.data.transport_id ? res.data.data.transport_id : null,
          vehicle_no: res.data.data.vehicle_no ? res.data.data.vehicle_no : "",
          transport_gst: res.data.data.transport_gst ? res.data.data.transport_gst : "",
          destination_place: res.data.data.destination_place ? res.data.data.destination_place : "",
          sub_total: res.data.data.sub_total,
          tax_amount: res.data.data.tax_amount,
          total_amount: res.data.data.total_amount,
          date: res.data.data.date ? res.data.data.date : "",
          remark: res.data.data.remark ? res.data.data.remark : "",
          ship_name: res.data.data.ship_name ? res.data.data.ship_name : "",
          ship_address_one: res.data.data.ship_address_one ? res.data.data.ship_address_one : "",
          ship_city_id: res.data.data.ship_city_id ? res.data.data.ship_city_id : "",
          ship_state_id: res.data.data.ship_state_id ? res.data.data.ship_state_id : "",
          ship_pincode: res.data.data.ship_pincode ? res.data.data.ship_pincode : "",
          ship_gst_no: res.data.data.ship_gst_no ? res.data.data.ship_gst_no : "",
          ship_pan_no: res.data.data.ship_pan_no ? res.data.data.ship_pan_no : "",
          prefix: res.data.data.prefix ? res.data.data.prefix : "",
          discount_amount: res.data.data.discount_amount ? res.data.data.discount_amount : "0",
          discount_rate: res.data.data.discount_rate ? res.data.data.discount_rate : "0",
          discount_type: res.data.data.discount_type ? res.data.data.discount_type : "Discount Before Tax",
          amount_received: res.data.data.amount_received ? res.data.data.amount_received : "0",
          received_type: res.data.data.received_type ? res.data.data.received_type : "CASH",
          items: [],
        });
        if (res.data.data.date) {
          setInvoiceDate(new Date(res.data.data.date));
        }
        if (res.data.data.lr_date) {
          setLrDate(new Date(res.data.data.lr_date));
        }
        let rows = res.data.data.items.map((row) => {
          return {
            id: row.id,
            name: row.product.name + (row.subproduct ? " - " + row.subproduct.name : ""),
            gst: row.product.gst,
            qty: row.qty,
            in_stock: row.in_stock,
            unit: row.unit,
            rate: row.rate,
            amount: row.amount,
            product_id: row.product_id,
            sub_product_id: row.sub_product_id,
          };
        });
        setItems(rows);
        if (res.data.data.party) {
          setSeller({
            address: res.data.data.party.address,
            city_id: res.data.data.party.city_id,
            city_name: res.data.data.party.city_name,
            state_id: res.data.data.party.state_id,
            state_name: res.data.data.party.state_name,
            pincode: res.data.data.party.pincode,
            gst_no: res.data.data.party.gst_no,
            pan_no: res.data.data.party.pan_no,
            name: res.data.data.party.name,
          });
        } else {
          setSeller({
            address: "",
            city_id: "",
            city_name: "",
            state_id: "",
            state_name: "",
            pincode: "",
            gst_no: "",
            pan_no: "",
            name: "",
          });
        }
        if (res.data.data.additional_charges && res.data.data.additional_charges.length > 0) {
          setCharges(res.data.data.additional_charges);
        }
        if (res.data.data.discount_amount && res.data.data.discount_rate && res.data.data.discount_amount > 0) {
          setIsDiscount(true);
        } else {
          setIsDiscount(false);
        }

      } else {
        toast.error(res.data.data, { autoClose: 3000 });
      }
      setLoading(false);
    });
  };

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: 101 })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formData.ship_state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const getQuickAddPartyStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: 101 })
      .then((res) => {
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setQuickAddPartyStateDrp(cd);
      });
  };

  const getQuickAddPartyCityDrpData = () => {
    if (quickAddPartyForm.state_id) {
      axios
        .post(API_URL.CITY_LIST, { state_id: quickAddPartyForm.state_id })
        .then((res) => {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name,
              value: caw.id,
            };
          });
          setQuickAddPartyCityDrp(cd);
        });
    }
  };

  const handleQuickAddPartyChange = (name, value) => {
    setQuickAddPartyForm({ ...quickAddPartyForm, [name]: value });
  };

  const saveQuickAddParty = () => {
    if (
      quickAddPartyForm.name &&
      quickAddPartyForm.city_id &&
      quickAddPartyForm.state_id &&
      quickAddPartyForm.contact_no
    ) {
      setIsSavingParty(true);
      axios.post(API_URL.PARTY_SAVE, { ...quickAddPartyForm, is_seller: 0 }).then((res) => {
        setIsSavingParty(false);
        if (res.data.status === 1) {
          toast.success("Party Added Successfully", { autoClose: 3000 });
          // Reset form
          setQuickAddPartyForm({
            name: "",
            email: "",
            contact_no: "",
            city_id: "",
            state_id: "",
            address: "",
            pincode: "",
            gst_no: "",
            pan_no: "",
            country_id: 101,
          });
          setShowQuickAddParty(false);
          getParty(res.data.data.id);
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      });
    } else {
      toast.error("Please fill all required fields", { autoClose: 3000 });
    }
  };

  const closeQuickAddPartyModal = () => {
    setShowQuickAddParty(false);
    setQuickAddPartyForm({
      name: "",
      email: "",
      contact_no: "",
      city_id: "",
      state_id: "",
      address: "",
      pincode: "",
      gst_no: "",
      pan_no: "",
      country_id: 101,
    });
  };

  const handleQuickAddTransportChange = (name, value) => {
    setQuickAddTransportForm({ ...quickAddTransportForm, [name]: value });
  };

  const saveQuickAddTransport = () => {
    if (quickAddTransportForm.name) {
      setIsSavingTransport(true);
      axios.post(API_URL.TRANSPORT_SAVE, quickAddTransportForm).then((res) => {
        setIsSavingTransport(false);
        if (res.data.status === 1) {
          toast.success("Transporter Added Successfully", { autoClose: 3000 });
          // Reset form
          setQuickAddTransportForm({
            name: "",
            gst_no: "",
          });
          setShowQuickAddTransport(false);
          // Refresh transport list
          setTransports([...transports, { label: res.data.data.name, value: res.data.data.id, gst_no: res.data.data.gst_no || "" }]);
          // Auto-select the newly added transport
          setTimeout(() => {
            if (res.data.data && res.data.data.id) {
              setFormData({
                ...formData,
                transport_id: res.data.data.id,
                transport_gst: res.data.data.gst_no || "",
              });
            }
          }, 100);
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      });
    } else {
      toast.error("Please enter transporter name", { autoClose: 3000 });
    }
  };

  const closeQuickAddTransportModal = () => {
    setShowQuickAddTransport(false);
    setQuickAddTransportForm({
      name: "",
      gst_no: "",
    });
  };

  const getProducts = () => {
    axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        res.data.data.map((raw) => {
          raw.label = raw.name;
          raw.value = raw.id;
        });
        setProducts(res.data.data);
      }
      if (!id) {
        setLoading(false);
      }
    });
  };

  const getTransport = () => {
    axios.post(API_URL.TRANSPORT_LIST, {}).then((res) => {
      if (res.data.status === 1) {
        res.data.data.forEach((r) => {
          r.label = r.name;
          r.value = r.id;
          r.id = r.id;
        });
        setTransports(res.data.data);
      }
    });
  };

  const setSelectedParty = (party_id) => {
    const party = partyData.find((r) => r.value == party_id);
    if (party) {
      setSeller(party);
      setFormData({
        ...formData,
        party_id: party_id,
        ship_name: party.name,
        ship_address_one: party.address,
        ship_city_id: party.city_id,
        ship_state_id: party.state_id,
        ship_pincode: party.pincode,
        ship_gst_no: party.gst_no,
        ship_pan_no: party.pan_no,
      });
    }
  };

  const setProductValue = (e) => {
    if (e) {
      setProductData({
        ...productData,
        name: e ? e.label : "",
        product_id: e ? e.product_id : null,
        sub_product_id: e ? e.sub_product_id : null,
        gst: e ? e.gst : "",
        rate: e.price ? e.price : 0,
        in_stock: e ? e.in_stock : "",
        unit: e ? e.unit : "",
        amount: (productData.qty) ? (productData.qty * e.price) : 0,
      });
    }
  };

  const addCharges = () => {
    let cpCharges = [...charges];
    cpCharges.push({
      title: "",
      amount: ""
    })
    setCharges(cpCharges);
  }

  const updateCharges = (val, field, ke) => {
    let cpCharges = [...charges];
    cpCharges[ke][field] = val;
    setCharges(cpCharges);
  }
  const removeCharges = (key) => {
    let cpCharges = [...charges];
    cpCharges.splice(key, 1);
    setCharges(cpCharges);
  }

  const addDiscount = () => {
    setIsDiscount(true);
  }

  const updateDiscount = (e, fieldName) => {
    if (fieldName == 'discount_rate') {
      if (e.target.value) {
        let disc = (formData.sub_total * e.target.value) / 100;
        setFormData({...formData, discount_rate: e.target.value, discount_amount: disc.toFixed(2) })
      }
    } else {
      if (e.target.value) {
        let disc = (100 * e.target.value) / formData.sub_total;
        setFormData({...formData, discount_amount: e.target.value, discount_rate: disc.toFixed(2) })
      }
    }
  }

  const removeDiscount = () => {
    setFormData({...formData, discount_amount: 0, discount_rate: 0 })
    setIsDiscount(false);
  }

  const addRow = () => {
    if (
      productData.product_id &&
      productData.qty &&
      productData.rate &&
      productData.amount
    ) {
      let cloneItems = [...items];
      cloneItems.push(productData);
      setItems(cloneItems);
      setProductData({
        name: "",
        product_id: "",
        sub_product_id: "",
        gst: "",
        in_stock: "",
        unit: "",
        qty: "",
        rate: "",
        amount: "",
      });
      selectInputRef.current.clearValue();
    }
  };

  const updateValue = (name, amt, value, k) => {
    const copyData = [...items];
    if (copyData[k]) {
      copyData[k][name] = value;
      if (name === "qty") copyData[k][amt] = value * copyData[k]["rate"];
      if (name === "rate") copyData[k][amt] = value * copyData[k]["qty"];
    }
    setItems(copyData);
  };

  const deleteRow = (index) => {
    const copyData = [...items];
    let newData = copyData.filter((e, key) => {
      return key != index;
    });
    setItems(newData);
  };

  const calculations = () => {
    let sub_total = 0;
    let total_qty = 0;
    let tax_amount = 0;
    items.forEach((row) => {
      sub_total += parseFloat(row.amount);
      total_qty += parseFloat(row.qty);
      tax_amount += (parseFloat(row.amount) * parseFloat(row.gst)) / 100;
    });
    let insurance_amount = 0;
    if (formData.insurance) {
      insurance_amount = (sub_total * formData.insurance) / 100;
      tax_amount += (parseFloat(insurance_amount) * 18) / 100;
      insurance_amount = insurance_amount.toFixed(2);
    }
    sub_total = sub_total.toFixed(2);
    let total_amount = parseFloat(sub_total) + parseFloat(insurance_amount);
    if (formData.round_off) {
      total_amount = parseFloat(total_amount) + parseFloat(formData.round_off);
    }
    if (tax_amount) {
      tax_amount = tax_amount.toFixed(2);
      total_amount = parseFloat(total_amount) + parseFloat(tax_amount);
    }
    if (charges.length) {
      charges.map((r) => {
        if (r.title && r.amount) {
          total_amount += parseFloat(r.amount);
        }
      });
    }
    if (formData.discount_amount && formData.discount_amount > -1) {
      total_amount = total_amount - parseFloat(formData.discount_amount);
    }
    total_amount = total_amount.toFixed(2);
    setFormData({
      ...formData,
      sub_total: sub_total,
      insurance_amount: insurance_amount,
      total_qty: total_qty,
      tax_amount: tax_amount,
      total_amount: total_amount,
    });
  };

  const isValidForm = () => {
    return (
      formData.party_id &&
      formData.prefix &&
      formData.invoice_no &&
      formData.sub_total &&
      formData.total_amount &&
      invoiceDate &&
      items.length
    );
  };

  const saveInvoice = () => {
    let payload = { ...formData };
    payload.items = [...items];
    payload.additional_charges = [...charges];
    payload.date = moment(invoiceDate).format("YYYY-MM-DD");
    if (lrDate) {
      payload.lr_date = moment(lrDate).format("YYYY-MM-DD");
    }
    const pUrl = id ? API_URL.INVOICE_UPDATE : API_URL.INVOICE_SAVE;
    if (id) {
      payload.id = id;
    }
    setIsLoading(true);
    axios.post(pUrl, payload).then(
      (res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", { autoClose: 3000 });
          } else {
            toast.success("Saved", { autoClose: 3000 });
          }
          setTimeout(() => {
            navigate("/invoice/view/" + res.data.data.id, {
              replace: true,
            });
          }, 100);
        } else {
          toast.error(res.data.data, {
            autoClose: 3000,

          });
        }
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    calculations();
  }, [items, formData.insurance, formData.round_off, charges, formData.discount_amount]);

  useEffect(() => {
    getParty(null);
    getProducts();
    getTransport();
  }, []);

  useEffect(() => {
    getStateDrpData();
  }, []);

  useEffect(() => {
    getCityDrpData();
  }, [formData.ship_state_id]);

  useEffect(() => {
    if (id) {
      getEdit();
    } else {
      getInvoice();
    }
  }, [id]);

  useEffect(() => {
    getQuickAddPartyStateDrpData();
  }, []);

  useEffect(() => {
    getQuickAddPartyCityDrpData();
  }, [quickAddPartyForm.state_id]);
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Invoice</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/sales/invoices"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-md-12">
          {loading && <Loader></Loader>}
          {!loading && (
            <>
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header">Billing Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="name">Party</label>
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ flex: 1 }}>
                                  <Select
                                    options={partyData}
                                    value={partyData.find(
                                      (r) => r.value == formData.party_id
                                    )}
                                    styles={styles}
                                    onChange={(e) => {
                                      setSelectedParty(e.value);
                                    }}
                                  />
                                </div>
                                <i onClick={() => setShowQuickAddParty(true)} style={{ cursor: "pointer", fontSize: 34 }} className="simple-icon-plus mx-1" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="state">State</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.state_name ? seller.state_name : ""}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="city">City</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.city_name ? seller.city_name : ""}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="state">Pincode</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.pincode ? seller.pincode : ""}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="address">Address</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.address}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gst_no">GST Number</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.gst_no ? seller.gst_no : ""}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="pan_no">Pan Number</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={seller.pan_no ? seller.pan_no : ""}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header">Shipping Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="party_name">Party</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ship_name}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_name: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="state">State</label>
                              <Select
                                options={stateDrp}
                                value={stateDrp.find(
                                  (r) => r.value == formData.ship_state_id
                                )}
                                styles={styles}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_state_id: e.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="city">City</label>
                              <Select
                                options={cityDrp}
                                value={cityDrp.find(
                                  (r) => r.value == formData.ship_city_id
                                )}
                                styles={styles}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_city_id: e.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="state">Pincode</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ship_pincode}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_pincode: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="ship_address_one">Address</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ship_address_one}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_address_one: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gst_no">GST Number</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ship_gst_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_gst_no: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="pan_no">Pan Number</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.ship_pan_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    ship_pan_no: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header">Invoice Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="pan_no">Prefix</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={formData.prefix ? formData.prefix : ""}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="invoiceno">Invoice No</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.invoice_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    invoice_no: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label htmlFor="">Invoice Date</label>
                              <DatePicker
                                format={"dd/MM/y"}
                                className="form-control"
                                onChange={setInvoiceDate}
                                value={invoiceDate}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="memo">Memo</label>
                              <Select
                                options={memoOptions}
                                styles={styles}
                                value={memoOptions.find(
                                  (r) => r.value == formData.invoice_memo
                                )}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    invoice_memo: e.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="insurance">Insurance (%)</label>
                              <input
                                type="number"
                                className="form-control"
                                value={formData.insurance}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    insurance: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group">
                              <label htmlFor="tax">
                                Tax is Payable on reverse charge?
                              </label>
                              <Select
                                options={taxOptions}
                                styles={styles}
                                value={taxOptions.find(
                                  (r) => r.value == formData.is_payable
                                )}
                                onChange={(e) =>
                                  setFormData({ ...formData, is_payable: e.value })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header">Transport Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="transporter">Transporter</label>
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ flex: 1 }}>
                                  <Select
                                    options={transports}
                                    styles={styles}
                                    value={transports.find(
                                      (r) => r.value == formData.transport_id
                                    )}
                                    onChange={(e) => {
                                      console.log(e);
                                      setFormData({
                                        ...formData,
                                        transport_id: e.value,
                                        transport_gst: e.gst_no,
                                      })
                                    }}
                                  />
                                </div>
                                <i onClick={() => setShowQuickAddTransport(true)} style={{ cursor: "pointer", fontSize: 34 }} className="simple-icon-plus mx-1" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="vehicleno">Vehicle No</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.vehicle_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    vehicle_no: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="lrno">LR No</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.lr_no}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lr_no: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="lrdate">LR Date</label>
                              <DatePicker
                                format={"dd/MM/y"}
                                className="form-control"
                                onChange={setLrDate}
                                value={lrDate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">Product Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Product</label>
                              <Select
                                ref={selectInputRef}
                                options={products}
                                styles={styles}
                                onChange={(e) => {
                                  setProductValue(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                Qty <span className="" style={{color: "red",fontSize: "13px",fontWeight: "600"}}>(Available: {productData.in_stock} {productData.unit})</span>
                              </label>
                              <input
                                type="number"
                                onChange={(e) => {
                                  setProductData({
                                    ...productData,
                                    qty: e.target.value,
                                    amount:
                                      e.target.value * productData.rate
                                        ? e.target.value * productData.rate
                                        : 0,
                                  });
                                }}
                                value={productData.qty}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Price</label>
                              <input
                                type="number"
                                onChange={(e) => {
                                  setProductData({
                                    ...productData,
                                    rate: e.target.value,
                                    amount:
                                      e.target.value * productData.qty
                                        ? e.target.value * productData.qty
                                        : 0,
                                  });
                                }}
                                value={productData.rate}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Amount</label>
                              <input
                                type="text"
                                value={productData.amount}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <label>&nbsp;</label>
                              <div>
                                <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {items.length > 0 && (
                        <table className="table table-hover">
                          <thead className="thead">
                            <tr>
                              <th>#</th>
                              <th colSpan={2} style={{ width: "45%" }}>Product</th>
                              <th>Qty</th>
                              <th>Price</th>
                              <th>Tax</th>
                              <th>Amount</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((e, k) => {
                              return (
                                <tr key={k}>
                                  <td>{k + 1}</td>
                                  <td colSpan={2} style={{ width: "45%" }}>{e.name}</td>
                                  <td>
                                    <input
                                      type="number"
                                      onChange={(event) => {
                                        updateValue(
                                          "qty",
                                          "amount",
                                          event.target.value,
                                          k
                                        );
                                      }}
                                      className="form-control form-control-sm"
                                      value={e.qty}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      onChange={(event) => {
                                        updateValue(
                                          "rate",
                                          "amount",
                                          event.target.value,
                                          k
                                        );
                                      }}
                                      className="form-control form-control-sm"
                                      value={e.rate}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={e.gst + "%"}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={e.amount}
                                      disabled
                                    />
                                  </td>
                                  <td style={{ cursor: "pointer", textAlign: 'right' }}>
                                    <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                  </td>
                                </tr>
                              );
                            })}
                            <tr className="border-top">
                              <td
                                className="border-end"
                                colSpan={5}
                                align={"right"}
                              ></td>
                              <td className="border-end" align={"right"}>
                                <strong>Taxable Amount</strong>
                              </td>
                              <td colSpan={1} align={"right"}>
                                <strong>{formData.sub_total}</strong>
                              </td>
                              <td></td>
                            </tr>
                            {formData.insurance ? (
                              <tr className="border-top">
                                <td
                                  className="border-end"
                                  colSpan={5}
                                  align={"right"}
                                ></td>
                                <td className="border-end" align={"right"}>
                                  <strong>Insurance ({formData.insurance}%)</strong>
                                </td>
                                <td colSpan={1} align={"right"}>
                                  <strong>{formData.insurance_amount}</strong>
                                </td>
                                <td></td>
                              </tr>
                            ) : null}
                            { isDiscount && <tr>
                              <td colSpan={3}></td>
                              <td colSpan={2}>
                                <Select
                                  options={discountOptions}
                                  value={discountOptions.find(
                                    (r) => r.value == formData.discount_type
                                  )}
                                  styles={styles}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      discount_type: e.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <div className="input-group">
                                  <span className="input-group-text" id="basic-addon1">%</span>
                                  <input type="number" placeholder="Percentage"  className="form-control" value={formData.discount_rate} onChange={(e) => updateDiscount(e, 'discount_rate')} />
                                </div>
                              </td>
                              <td>
                                <div className="input-group">
                                  <span className="input-group-text" id="basic-addon1">₹</span>
                                  <input type="number" placeholder="Amount" className="form-control" value={formData.discount_amount} onChange={(e) => updateDiscount(e, 'discount_amount')} />
                                </div>
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>
                                  <i style={{ fontSize: 16, cursor: 'pointer' }} onClick={removeDiscount} className="simple-icon-close text-danger"></i>
                              </td>
                            </tr> }
                            { !isDiscount && <tr>
                              <td colSpan={3}></td>
                              <td colSpan={4} className="text-right">
                                <span style={{ cursor: 'pointer', color: 'blue' }} onClick={addDiscount}>Add Discount</span>
                              </td>
                              <td></td>
                            </tr> }
                            {charges.map((row, kk) => {
                              return <tr key={kk}>
                                <td colSpan={4}></td>
                                <td colSpan={2}>
                                  <input type="text" className="form-control" value={row.title} onChange={(e) => updateCharges(e.target.value, 'title', kk)} />
                                </td>
                                <td colSpan={1}>
                                  <input type="number" className="form-control" value={row.amount} onChange={(e) => updateCharges(e.target.value, 'amount', kk)} />
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>
                                  <i style={{ fontSize: 16, cursor: 'pointer' }} onClick={() => { removeCharges(kk) }} className="simple-icon-close text-danger"></i>
                                </td>
                              </tr>
                            })
                            }
                            <tr>
                              <td colSpan={3}></td>
                              <td colSpan={4} className="text-right">
                                <span style={{ cursor: 'pointer', color: 'blue' }} onClick={addCharges}>Additional Charges</span>
                              </td>
                              <td></td>
                            </tr>
                            <tr className="border-top">
                              <td
                                className="border-end"
                                colSpan={5}
                                align={"right"}
                              ></td>
                              <td className="border-end" align={"right"}>
                                <strong>IGST</strong>
                              </td>
                              <td colSpan={1} align={"right"}>
                                <strong>{formData.tax_amount}</strong>
                              </td>
                              <td></td>
                            </tr>
                            <tr className="border-top">
                              <td className="vertical-middle">
                                <label htmlFor="remarks" className="mb-0">Remark</label>
                              </td>
                              <td className="border-end" colSpan={4}>
                                <input
                                  id="remark"
                                  type={"text"}
                                  maxLength={255}
                                  value={formData.remark}
                                  placeholder="Remark"
                                  className="form-control"
                                  onChange={(e) =>
                                    setFormData({ ...formData, remark: e.target.value })
                                  }
                                />
                              </td>
                              <td className="border-end vertical-middle" align={"right"}>
                                <strong>Round Off</strong>
                              </td>
                              <td colSpan={1} align={"right"}>
                                {" "}
                                <input
                                  type={"number"}
                                  value={formData.round_off}
                                  className="form-control form-control-sm text-right"
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      round_off: e.target.value,
                                    })
                                  }
                                />{" "}
                              </td>
                              <td></td>
                            </tr>
                            <tr className="border-top">
                              <td className="border-end" align={"right"} colSpan={6}>
                                <strong>Final Amount</strong>
                              </td>
                              <td align={"right"}>
                                <strong>{formData.total_amount}</strong>
                              </td>
                              <td></td>
                            </tr>
                            <tr className="border-top">
                              <td className="border-end" align={"right"} colSpan={5} style={{verticalAlign: 'middle'}}>
                                <strong>Amount Received</strong>
                              </td>
                              <td align={"right"}>
                                <input type="number" className="form-control" value={formData.amount_received} onChange={(e) => setFormData({...formData, amount_received: e.target.value})} />
                              </td>
                              <td>
                                <Select
                                  id="received_type"
                                  name="received_type"
                                  options={modeTypeDrp}
                                  value={
                                    modeTypeDrp.find((d) => d.value == formData.received_type) ||
                                    null
                                  }
                                  styles={selectStyles}
                                  onChange={(e) => setFormData({...formData, received_type: e.value})}
                                />
                              </td>
                              <td></td>
                            </tr>
                            { (formData.total_amount && formData.amount_received) && <tr className="border-top">
                              <td className="border-end" align={"right"} colSpan={5} style={{verticalAlign: 'middle'}}>
                                <strong>Balance Amount</strong>
                              </td>
                              <td></td>
                              <td align={"right"}>
                                {parseFloat(formData.total_amount) - parseFloat(formData.amount_received)}
                              </td>
                              <td>
                              </td>
                            </tr> }
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="form-group text-right">
                  <button
                    type="button"
                    onClick={saveInvoice}
                    disabled={!isValidForm() || isLoading}
                    className="btn btn-primary"
                  >
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                    ) : null}
                    Save
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Quick Add Party Modal */}
      {showQuickAddParty && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeQuickAddPartyModal();
            }
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h5 className="modal-title">Quick Add Party</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeQuickAddPartyModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={quickAddPartyForm.name}
                        onChange={(e) => handleQuickAddPartyChange("name", e.target.value)}
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        value={quickAddPartyForm.email}
                        onChange={(e) => handleQuickAddPartyChange("email", e.target.value)}
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Contact Number<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={quickAddPartyForm.contact_no}
                        onChange={(e) => handleQuickAddPartyChange("contact_no", e.target.value)}
                        className="form-control"
                        placeholder="Contact Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>State<span className="text-danger">*</span></label>
                      <Select
                        options={quickAddPartyStateDrp}
                        value={quickAddPartyStateDrp.find((r) => r.value == quickAddPartyForm.state_id)}
                        styles={styles}
                        onChange={(e) => handleQuickAddPartyChange("state_id", e.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="City">City<span className="text-danger">*</span></label>
                      <Select
                        options={quickAddPartyCityDrp}
                        value={quickAddPartyCityDrp.find((r) => r.value == quickAddPartyForm.city_id)}
                        styles={styles}
                        onChange={(e) => handleQuickAddPartyChange("city_id", e.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        value={quickAddPartyForm.address}
                        onChange={(e) => handleQuickAddPartyChange("address", e.target.value)}
                        className="form-control"
                        placeholder="Address"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Pincode</label>
                      <input
                        type="text"
                        value={quickAddPartyForm.pincode}
                        onChange={(e) => handleQuickAddPartyChange("pincode", e.target.value)}
                        className="form-control"
                        placeholder="Pincode"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        value={quickAddPartyForm.gst_no}
                        onChange={(e) => handleQuickAddPartyChange("gst_no", e.target.value)}
                        className="form-control"
                        placeholder="GST Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Pan Number</label>
                      <input
                        type="text"
                        value={quickAddPartyForm.pan_no}
                        onChange={(e) => handleQuickAddPartyChange("pan_no", e.target.value)}
                        className="form-control"
                        placeholder="Pan Number"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeQuickAddPartyModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveQuickAddParty}
                  disabled={isSavingParty || !quickAddPartyForm.name || !quickAddPartyForm.city_id || !quickAddPartyForm.state_id || !quickAddPartyForm.contact_no}
                >
                  {isSavingParty ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save Party"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Quick Add Transporter Modal */}
      {showQuickAddTransport && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeQuickAddTransportModal();
            }
          }}
        >
          <div className="modal-dialog">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h5 className="modal-title">Quick Add Transporter</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeQuickAddTransportModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={quickAddTransportForm.name}
                        onChange={(e) => handleQuickAddTransportChange("name", e.target.value)}
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        value={quickAddTransportForm.gst_no}
                        onChange={(e) => handleQuickAddTransportChange("gst_no", e.target.value)}
                        className="form-control"
                        placeholder="GST Number"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeQuickAddTransportModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveQuickAddTransport}
                  disabled={isSavingTransport || !quickAddTransportForm.name}
                >
                  {isSavingTransport ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save Transporter"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddInvoice;
